export default __webpack_public_path__ + "static/media/cloud-tools-icon.11b31ae8.svg";